import c from "./constants";
import { postNewEntryService, getHappinessForUser } from "./services";
import { toast } from "react-toastify";
import { getUserById } from "../user/services";

export function postNewEntry(entry) {
  const begin = () => ({ type: c.POST_BEGIN });
  const success = () => ({ type: c.POST_SUCCESS });
  const failure = error => ({ type: c.POST_FAILURE, payload: error });

  return async dispatch => {
    dispatch(begin());
    postNewEntryService(entry)
      .then(() => {
        dispatch(success());
        toast("New entry posted!");
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };
}

export function getAllHappinessForUser(userId) {
  const begin = () => ({ type: c.GET_HAPPINESS_BEGIN });
  const success = data => ({ type: c.GET_HAPPINESS_SUCCESS, payload: data });
  const failure = error => ({ type: c.GET_HAPPINESS_FAILURE, payload: error });

  return async dispatch => {
    dispatch(begin());
    getHappinessForUser(userId)
      .then(data => {
        dispatch(success(data));
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };
}
export function getUserInformation(userId) {
  const begin = () => ({ type: c.GET_USER_BEGIN });
  const success = data => ({ type: c.GET_USER_SUCCESS, payload: data });
  const failure = error => ({ type: c.GET_USER_FAILURE, payload: error });

  return async dispatch => {
    dispatch(begin());
    getUserById(userId)
      .then(data => {
        dispatch(success(data));
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };
}



// WEBPACK FOOTER //
// ./src/modules/diary/actions.js